<template>
  <v-container fluid v-show="show">
    <v-row>
      <v-col cols="12" md="6">
        <wapi-panel :title="'Договор'">
          <template v-slot:content>
            <v-container fluid>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-model="contract.name"
                  label="Название договора"
                  :rules="[rules.required]"
                  dense
                  outlined
                ></v-text-field>
                <v-select
                  v-model="contract.user_id"
                  :items="users"
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="id"
                  label="Клиент"
                  dense
                  outlined
                  :disabled="userDisabled"
                ></v-select>
                <v-radio-group v-model="contract.status">
                  <v-radio :label="`Активный`" :value="1" dense></v-radio>
                  <v-radio :label="`Не активный`" :value="0" dense></v-radio>
                </v-radio-group>
                <!-- Дата закрытия договора -->

                <wapi-date-picker
                  v-model="contract.expiration_date"
                  :label="`Дата закрытия договора`"
                ></wapi-date-picker>

                <div v-if="contract.limit_settings">
                  <v-text-field
                    v-model.number="contract.limit_settings.max_preset_area"
                    label="Максимальная площадь территорий (км2)"
                    :rules="[rules.required]"
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-model.number="contract.limit_settings.max_area_request"
                    label="Максимальная площадь за сутки для запросов прогнозов (км2)"
                    :rules="[rules.required]"
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-model.number="contract.limit_settings.max_point_request_count"
                    label="Максимальное количество запросов прогнозов в точке за сутки"
                    :rules="[rules.required]"
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-model.number="contract.limit_settings.max_preset_request_count"
                    label="Максимальное количество запросов прогнозов по территориям за сутки"
                    :rules="[rules.required]"
                    dense
                  ></v-text-field>
                  <v-checkbox
                    v-model="contract.limit_settings.is_strict_restriction"
                    :label="`Использовать строгое ограничение`"
                    dense
                  ></v-checkbox>
                </div>

                <wapi-preset-settings-select v-model="contract.preset_settings" />

                <wapi-contract-notifications v-model="contract.notification_settings" />
                <div v-if="contract.notification_settings">
                  <v-combobox
                    v-model="contract.notification_settings.emails"
                    :items="contract.notification_settings.emails"
                    label="Почтовые ящики пользователя"
                    multiple
                    :rules="[rules.required]"
                    dense
                    :outlined="true"
                  ></v-combobox>
                </div>

                <div class="d-flex justify-end">
                  <v-btn v-on:click="save" text color="primary">Сохранить</v-btn>
                  <v-btn v-on:click="back" text color="error">Закрыть</v-btn>
                </div>
              </v-form>
            </v-container>
          </template>
        </wapi-panel>
      </v-col>
      <v-col cols="12" md="6">
        <wapi-panel :title="'Свойства договора'">
          <template v-slot:content>
            <h5>Свойства домена</h5>
            <p>Отметьте галочкой те параметры и заблаговременности, которые вы хотите включить в договор</p>
            <v-card>
              <v-tabs background-color="primary" dark>
                <v-tab>Прогнозы</v-tab>
                <v-tab>Реанализ</v-tab>
                <v-tab-item>
                  <v-card>
                    <selected-domain-list :model="domainsModel" />
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <reanalysis-settings
                    v-model="contract.reanalysis_settings"
                    :parameters="reanalysisParameters"
                  />
                </v-tab-item>
              </v-tabs>
            </v-card>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../../models/contract/WapiContract.js";

import SelectedDomainList from "../../components/SelectedDomainList.vue";

import rules from "../../models/helpers/rules";
import WapiPanel from "../../components/WapiPanel";
import WapiContractNotifications from "../../components/WapiContractNotifications";
import ReanalysisSettings from "./components/ReanalysisSettings.vue";

import { toPredictsViewModel } from "../../models/mappers/predicts.js";
import { fixProps } from "../../models/contract/Helpers.js";
import {
  toDomainsViewModel,
  toWapiDvariant
} from "../../models/mappers/domains";
import WapiForecastSettings from "../../models/contract/WapiForecastSettings.js";
import WapiPresetSettingsSelect from "./components/WapiPresetSettingsSelect.vue";
import WapiDatePicker from "../../components/WapiDatePicker.vue";

export default {
  name: "Contracts",
  title: "Договор",
  components: {
    SelectedDomainList,
    WapiPanel,
    WapiContractNotifications,
    ReanalysisSettings,
    WapiPresetSettingsSelect,
    WapiDatePicker
  },
  props: {
    contractId: String,
    userId: String
  },
  data: function() {
    return {
      /**
       * @type WapiContract
       */
      contract: new WapiContract(),
      mode: "",
      domainsPredicts: [],
      dvariants: [],
      domainsList: [],
      domainsModel: [],
      parameters: [],
      // модель для обработки на клиенте
      domains: [],
      users: [],
      predictRanges: [],
      predicts: [],
      rules: rules,
      valid: true,
      menuExpirationDate: false,
      exRules: {
        notZero: value => value <= 0 || `Значение не должно быть = [${value}].`
      },
      show: true,
      reanalysisSettings: {},
      reanalysisParameters: []
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async onChangeUser() {},
    async init() {
      await this.$store.dispatch("SET_LOADING", true);
      try {
        this.users = await this.$store.dispatch("FETCH_USERS");
        this.domains = await this.$store.dispatch("FETCH_DOMAINS");
        for (const d of this.domains) {
          const params = await this.$store.dispatch("FETCH_PARAMETERS", {
            domain: d.name
          });
          this.parameters.push({ domain: d.name, parameters: params });
        }

        const reanalysisParameters = await this.$store.dispatch(
          "FETCH_REANALYSIS_PARAMETERS"
        );
        this.reanalysisParameters = reanalysisParameters.map(x => x.sname);
        this.predictRanges = this.$store.getters.PREDICTRANGES;
        this.predicts = toPredictsViewModel(this.predictRanges);
        this.show = false;

        if (this.contractId) {
          await this.$store.dispatch("FETCH_CONTRACTS", this.userId);
          this.contract = this.$store.getters.CONTRACT_BY_ID(this.contractId);
        }

        await this.$store.dispatch("FETCH_DOMAINS_PREDICTS");
        this.domainsPredicts = this.$store.getters.DOMAINS_PREDICTS;
        this.domainsModel = toDomainsViewModel(
          this.domains,
          this.predictRanges,
          this.contract,
          this.domainsPredicts,
          this.parameters
        );

        this.$refs.form.resetValidation();
      } catch (err) {
        this.$store.dispatch("PUSH_ERROR", err);
      }

      await this.$store.dispatch("SET_LOADING", false);
      this.show = true;
    },

    async reset() {
      this.predictRanges = [];
      this.contract = {};
      this.domainsModel = [];
      this.parametersLayers = [];
      this.predicts = [];
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      try {
        const checkedDomains = this.domainsModel.filter(x => x.checked);

        if (!checkedDomains.length) {
          this.$store.dispatch(
            "PUSH_ERROR_MESSAGE",
            "Должен быть выбран хотя бы [1] домен!"
          );
          return;
        }

        await this.$store.dispatch("SET_LOADING", true);
        const dvariants = toWapiDvariant(this.domainsModel);
        this.contract.forecast_settings = new WapiForecastSettings();
        this.contract.forecast_settings.dvariants = dvariants;

        fixProps(this.contract);

        if (this.contract.id) {
          await this.$store.dispatch("UPDATE_CONTRACT", this.contract);
        } else {
          let newContract = await this.$store.dispatch(
            "CREATE_CONTRACT",
            this.contract
          );
          this.contract.id = newContract.id;
        }
      } catch (err) {
        this.$store.dispatch("PUSH_ERROR", err);
      }

      await this.$store.dispatch("SET_LOADING", false);
    }
  },
  computed: {
    contracts() {
      return this.$store.getters.CONTRACTS;
    },
    userDisabled() {
      return !!this.contract.id;
    },
    loading() {
      return this.$store.getters.LOADING;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.reset();
      if (vm.contractId) {
        await vm.init();
      } else {
        vm.contract = new WapiContract();
        await vm.init();
      }
    });
  }
};
</script>